import { Link } from "react-router-dom";
import { Button } from "@/components/ui";
import { useAuth } from "@/state/auth";

/**
 * A 403 that tells someone what to do next.
 *
 * "Access denied" makes a person think the software is broken. Naming their
 * role and who can change it turns a dead end into a one-line message to their
 * account owner.
 */
export function Forbidden() {
  const { roleLabel } = useAuth();
  return (
    <div className="ws-card px-6 py-16 text-center">
      <p className="font-mono text-sm text-ink-400">403</p>
      <h1 className="mt-2 text-2xl font-bold tracking-tight">You do not have access to this</h1>
      <p className="mx-auto mt-2 max-w-md text-sm text-ink-500">
        Your role is {roleLabel || "not set"}, which does not include this page. An account owner or
        admin can change that under Team.
      </p>
      <Link to="/app" className="mt-6 inline-block">
        <Button>Back to your overview</Button>
      </Link>
    </div>
  );
}
